<template>
    <LineChart :id="chartID" :chart-options="mChartOptions" :chart-data="mChartData" />
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { Line as LineChart } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale)

// Read after register so ChartJS defaults are fully populated
const defaultLegendClickHandler = ChartJS.defaults?.plugins?.legend?.onClick

export default {
    name: 'LineChartComponent',
    components: { LineChart },
    props: {
        chartID: String,
        chartData: Object,
        legendHandler: Function,
        legendsMaxLength: Number
    },
    data() {
        return {
            mChartData: {},
            mChartOptions: {}
        }
    },
    watch: {
        chartData: {
            immediate: true,
            handler: function (newValue) {
                let temp = deepCopy(newValue)
                for (let i = 0; i < temp.datasets.length; i++) {
                    // let d = temp.datasets[i]
                    // let color = d.borderColor
                    // let image = this.getCircleImage(color)
                    // temp.datasets[i].pointStyle = image
                }
                this.mChartData = temp
            }
        },
        chartOptions: {
            immediate: true,
            handler: function (newValue) {
                if (newValue.plugins == undefined) {
                    newValue.plugins = {}
                }
                if (newValue.plugins.legend == undefined) {
                    newValue.plugins.legend = {}
                }
                newValue.plugins.legend.onClick = this.action_Legend
                this.mChartOptions = newValue
            }
        }
    },
    computed: {
        chartOptions: function () {
            return {
                // layout: {
                //     padding: 10
                // },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        ticks: {
                            // align: 'start'
                            // padding: 30
                            // 'padding-left': 30
                        }
                    },
                    y: {
                        type: 'linear',
                        // grace: '30%',
                        grid: {
                            display: true,
                            drawTicks: true,
                            lineWidth: 1,
                            color: function (context) {
                                if (Number.isInteger(context.tick.value)) {
                                    return '#DFDFE0'
                                }
                                return '#00000000'
                            }
                        },
                        ticks: {
                            min: 0,
                            callback: function (value) {
                                return Number.isInteger(value) ? value : '' // 정수 값만 표시
                            }
                        }
                    }
                },
                elements: {
                    point: {
                        radius: 2,
                        borderWidth: 5
                        // hoberBorderWidth: 5,
                    }
                },
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            radius: 2,
                            borderWidth: 5,
                            boxHeight: 4,
                            generateLabels: (chart) => {
                                return chart.data.datasets.map((dataset, i) => ({
                                    text: dataset.label.length > this.legendsMaxLength ? dataset.label.substring(0, this.legendsMaxLength) + '...' : dataset.label,
                                    fillStyle: dataset.borderColor,
                                    hidden: !chart.isDatasetVisible(i),
                                    datasetIndex: i
                                }))
                            }
                        },
                        maxWidth: 100,
                        position: 'bottom'
                    },
                    title: {
                        display: false
                    }
                }
            }
        }
    },
    methods: {
        action_Legend(e, legendItem, legend) {
            // legendItem.datasetIndex = legendItem.index
            defaultLegendClickHandler(e, legendItem, legend)

            if (this.legendHandler == undefined) {
                return
            }
            this.legendHandler(e, legendItem, legend)
        },

        getCircleImage(color) {
            var canvas = document.createElement('canvas')
            let size = 12
            canvas.width = size
            canvas.height = size
            var ctx = canvas.getContext('2d')

            ctx.beginPath()
            ctx.arc(size / 2, size / 2, size / 2, 0, 2 * Math.PI)
            ctx.fillStyle = color
            ctx.fill()

            var img = new Image()
            img.src = canvas.toDataURL()
            img.pointRadius = size / 2
            return img
        }
    }
}
</script>
